import { render, staticRenderFns } from "./ProductSold.vue?vue&type=template&id=00d7fdc0&scoped=true&"
import script from "./ProductSold.vue?vue&type=script&lang=js&"
export * from "./ProductSold.vue?vue&type=script&lang=js&"
import style0 from "./ProductSold.vue?vue&type=style&index=0&id=00d7fdc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d7fdc0",
  null
  
)

export default component.exports